import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ExtendedFormControlsComponent } from '../../extended-form-controls/extended-form-controls.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';
import { ReviewService } from 'src/app/services/common/review.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { serviceConstants } from 'src/app/constants/service.constants';
import { CalendarModule } from 'primeng/calendar';
import { ReviewContributorsModelComponent } from '../../schedule-review/review-contributors-model/review-contributors-model.component';
import { ReviewDocumentsModelComponent } from '../../schedule-review/review-documents-model/review-documents-model.component';
import * as $ from 'jquery';
import { DateObject, DocumentUploadFile } from 'src/app/models/common';

@Component({
  selector: 'app-setup-approval-model',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,DropdownModule,CalendarModule],
  templateUrl: './setup-approval-model.component.html',
  styleUrl: './setup-approval-model.component.scss'
})
export class SetupApprovalModelComponent {

   @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
   @Input() public Content: any;
   setUpApprovalForm: UntypedFormGroup;
   randomList : any= [];
   isSeletedOthers: boolean = false;
   IsChangeOwner: boolean = false;
   SelectDocs: any[] = [];
   ApprovalOwnerddlOptions: any[] = [];
   ReferenceDocs: any[] = [];
   internalUsers: any[] = [];
   selectedUsers: any[]=[];
   disabledDates: Date [] = [];
   minDate: Date;
  selectedRolesInPop: any = [];
  SubModule: any;
  ModuleID: any;
  appId: any;
  appCode: any;
  userType: string;
  type: any;
  appStatus: any;
  ApplicationID: any;
  isDocFromSystem :boolean = false;
  isApprovalDocfromApp: boolean = false;
  user: any;
  IsPlannedDateModified: boolean = false;
  PlannedEndDate: DateObject;
  CurrentDate: Date;
  minPStartDate = new Date();
  maxPStartDate: Date | undefined;
  minPEndDate = new Date();
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Planned_Date: DateObject;
  ApprovalId: any;
  uploadedFiles: any[] = [];
  IsView: boolean = false;

    constructor(public modalRef: NgbActiveModal,
      private modalService: NgbModal,
      private userService: UserService,
      private reviewService: ReviewService,
      private commonService: CommonService,
      private activatedRoute: ActivatedRoute
      ){}
    ngOnInit() {

      this.minDate = new Date();
    if (this.Content.content !== null) {
      this.type = this.Content.content.type;
      this.SubModule = this.Content.content.subModule;
      this.ModuleID = this.Content.content.module;
      this.appId = this.Content.content.applicationId;
      this.appCode = this.Content.content.applicationCode;  
      this.appStatus = this.Content.content.applicationStatus;  
      if(this.Content.content.ApprovalId!=null && this.Content.content.ApprovalId!="" && this.Content.content.ApprovalId!=undefined)
       {
           this.ApprovalId = this.Content.content.ApprovalId;
       }
       if(this.Content.content.IsChangeOwner!=null && this.Content.content.IsChangeOwner!="" && this.Content.content.IsChangeOwner!=undefined)
       {
           this.IsChangeOwner = this.Content.content.IsChangeOwner;
       }
      if (this.Content.heading != null && this.Content.heading != "" && this.Content.heading != undefined) {
        if (this.Content.heading == "View") {
           this.IsView = true;
        }
       }       
    }     
    //Fetch Approval Types
    this.reviewService.GetReviewTypes("api/Approval/GetApprovalTypes?moduleId=" + this.ModuleID + "&subModule=" + this.SubModule).subscribe((summary) => {
      this.randomList = summary;
      this.randomList.push({ label: "Other", value: "Other" });
    });
    
  
    this.userType = this.userService.getUserType();

    
    if(this.Content.content.ApprovalId!=null && this.Content.content.ApprovalId!="" && this.Content.content.ApprovalId!=undefined)
    {
      this.GetSetUpApprovalDetailsById();           
    }
    else{
      this.GetOwner();
    }

      this.setUpApprovalForm = new UntypedFormGroup({
            ID: new UntypedFormControl(null),
            Application_ID: new UntypedFormControl(null),
            Application_Code: new UntypedFormControl(null),
            Application_Status: new UntypedFormControl(null),
            Title: new UntypedFormControl(""),
            APPROVAL_TYPE: new UntypedFormControl(""),
            PlannedEndDate: new UntypedFormControl(null),
            PlannedEndDateO: new UntypedFormControl(null),
            ApprovalOwner: new UntypedFormControl(null),
            ApprovalOwnerddl: new UntypedFormControl(null),
            ApprovalOwnerName: new UntypedFormControl(null),
            ApprovalReviewStatus: new UntypedFormControl(null),
            ApprovalDescription: new UntypedFormControl(null),
            //ActualStartDate: new UntypedFormControl(null),
            //ActualEndDate: new UntypedFormControl(null),
            Documents: new UntypedFormControl(null),
            ReferenceDocuments: new UntypedFormControl(null),
            documaent_attach_list: new UntypedFormControl(null)
          });
      this.setUpApprovalForm.controls["ApprovalReviewStatus"].setValue("Pending");
      this.setUpApprovalForm.controls["ApprovalReviewStatus"].disable();
      this.setUpApprovalForm.controls["ApprovalOwnerddl"].disable();

      
    }

  GetOwner() {
    this.ApprovalOwnerddlOptions=[];
    this.reviewService.GetOwner("api/Review/GetOwner?ApplicationID=" + this.appId + "&Module=" + this.ModuleID).subscribe(result => {
      if (result) {
        this.user = result;
        this.ApprovalOwnerddlOptions=[{ UserName: this.user.UserName, UserID: this.user.UserID ,checked: true}];
        this.setUpApprovalForm.controls["ApprovalOwnerddl"].setValue(this.user.UserID);
        this.setUpApprovalForm.controls["ApprovalOwnerName"].setValue(this.user.UserName);
      }
    });

    this.reviewService.GetReviewTypes("api/Approval/GetApprovalTypes?moduleId=" + this.ModuleID + "&subModule=" + this.SubModule).subscribe((summary) => {
      this.randomList = summary;
      this.randomList.push({ label: "Other", value: "Other" });
    });
  }

  GetSetUpApprovalDetailsById() {

    this.ApprovalOwnerddlOptions = [];
    let today = new Date(); today.setHours(0,0,0,0);
    this.reviewService.EditReview("api/Approval/EditApproval?Id=" + this.ApprovalId).subscribe(result => {
      if (result) {
        // this.setUpApprovalForm.patchValue({
        //   PlannedEndDate:new Date(result["PlannedEndDate"])
        // });
        this.setUpApprovalForm.controls["Title"].setValue(result["Title"]); 
        this.GetOwner();
        this.setUpApprovalForm.controls["APPROVAL_TYPE"].disable();
        this.setUpApprovalForm.controls["Title"].disable();
        this.CurrentDate = this.commonService.getdisplayedDate(result["PlannedEndDate"]);  
        let date = new Date(this.CurrentDate)
        date.setHours(0,0,0,0);
        while (date < today) {
          this.disabledDates.push(new Date(date));
          date.setDate(date.getDate() + 1);
        }
        //setTimeout(() => {
          this.setUpApprovalForm.controls["PlannedEndDate"].setValue(this.CurrentDate);
        //}, 100);

        if (this.CurrentDate < today) {
          this.minDate = this.CurrentDate;
        }

         this.setUpApprovalForm.controls["ApprovalReviewStatus"].setValue(result["strApprovalReviewStatus"]);
         this.setUpApprovalForm.controls["ApprovalDescription"].setValue(result["ApprovalDescription"]);

        if (result["isApprovalDocfromApp"]) {
          this.SelectDocs= result["Documents"];
        }
        else {
          this.SelectDocs = result["Documents"];
        }
        this.isApprovalDocfromApp = result["isApprovalDocfromApp"];
        this.ReferenceDocs = result["ReferenceDocuments"];
        this.selectedUsers = result["Approvers"];  
        
       // this.selectedRolesInPop = result["ReviewersRoles"];
        this.setUpApprovalForm.controls["APPROVAL_TYPE"].setValue(result["Approval_Type"]);
        this.ApprovalOwnerddlOptions = result["lstusers"];
        this.ApprovalOwnerddlOptions = [{ UserName: "Select", UserID: "", checked: true }].concat(this.ApprovalOwnerddlOptions);
        if(this.IsChangeOwner || this.IsView)
          {             
            this.setUpApprovalForm.controls["Title"].disable();
            this.setUpApprovalForm.controls["PlannedEndDate"].disable();
            this.setUpApprovalForm.controls["ApprovalOwner"].disable();
            if(this.IsView)
            {
            this.setUpApprovalForm.controls["ApprovalOwnerddl"].disable();
            setTimeout(() => {
                this.ApprovalOwnerddlOptions = result["lstusers"];
                this.ApprovalOwnerddlOptions = [{ UserName: "Select", UserID: "", checked: true }].concat(this.ApprovalOwnerddlOptions);
                this.setUpApprovalForm.controls["ApprovalOwnerddl"].setValue(result["ApprovalOwner"]);
              }, 300);
            }
            if(this.IsChangeOwner)
            {
            this.setUpApprovalForm.controls["ApprovalOwnerddl"].enable();
              setTimeout(() => {
                this.ApprovalOwnerddlOptions = result["lstusers"];
                this.ApprovalOwnerddlOptions = [{ UserName: "Select", UserID: "", checked: true }].concat(this.ApprovalOwnerddlOptions);
                this.setUpApprovalForm.controls["ApprovalOwnerddl"].setValue(result["ApprovalOwner"]);
              }, 300);
            }

            this.setUpApprovalForm.controls["ApprovalReviewStatus"].disable();
            this.setUpApprovalForm.controls["ApprovalDescription"].disable();
          }
          this.setUpApprovalForm.controls["ApprovalOwnerddl"].setValue(result["ApprovalOwner"]);
      }
    });
  }

  CompareDates(oldDate: any, newDate: any): boolean {   
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }

    GetStartDate(): DateObject { 
      let formModel = this.setUpApprovalForm.getRawValue();
      const lDate = new Date(formModel.PlannedEndDate);
      if ((this.CompareDates(this.CurrentDate, lDate) || this.Planned_Date == null || this.Planned_Date == undefined) &&
       formModel.PlannedEndDate != null) {
        this.Planned_Date = {
          Day: lDate.getDate(),
          Month: lDate.getMonth() + 1,
          Year: lDate.getFullYear(),
          Hours: 23,
           Minutes: 59,
           Seconds: 59,
           IsEndDate: true,
           HasValue: true,
          IsDateModified: false
        }
      }
      else {
        this.Planned_Date = {
          Day: lDate.getDate(),
          Month: lDate.getMonth() + 1,
          Year: lDate.getFullYear(),
          Hours: 23,
          Minutes: 59,
          Seconds: 59,
          IsEndDate: true,
          HasValue: true,
          IsDateModified: true
        }
      }
      return this.Planned_Date
    }

    save(){
      if (!this.IsChangeOwner) {
        if (this.validateControls()) {   
        let formData = this.setUpApprovalForm.value;
        formData["ID"]= this.ApprovalId;
        formData["Application_ID"] = this.appId;
        formData["Application_Code"] = this.appCode;
        formData["Application_Status"] = this.appStatus;
        formData["ModuleID"] = this.ModuleID;
        formData["SubModule"] = this.SubModule;
        formData["Title"] = this.setUpApprovalForm.controls["Title"].value;
        let planned = this.GetStartDate();
        formData["PlannedEndDate"] = this.setUpApprovalForm.controls["PlannedEndDate"].value;
        formData["PlannedEndDateO"] = planned;
        formData["ApprovalOwner"] = this.setUpApprovalForm.controls["ApprovalOwnerddl"].value;
        formData["ApprovalOwnerName"] = this.setUpApprovalForm.controls["ApprovalOwnerName"].value;
        formData["ApprovalDescription"] = this.setUpApprovalForm.controls["ApprovalDescription"].value;
        formData["Documents"] = this.SelectDocs;
        formData["isApprovalDocfromApp"] = this.isApprovalDocfromApp;
        formData["ReferenceDocuments"] = this.ReferenceDocs;        
        formData["Approvers"] = this.selectedUsers;
        //formData["ReviewersRoles"] = this.selectedRolesInPop;
        formData["Approval_Type"] = this.setUpApprovalForm.controls["APPROVAL_TYPE"].value == "Other" ? "": this.setUpApprovalForm.controls["APPROVAL_TYPE"].value;
        let formData1 = new FormData();
        
        if (this.uploadedFiles != null && this.uploadedFiles.length > 0) {       
          for (let i = 0; i < this.uploadedFiles.length; i++) {        
              this.uploadedFiles[i].TRANSACTION_ID = ("" + (i + 1));
              formData1.append(("" + (i + 1)), this.uploadedFiles[i].File);
          }
        }
  
        formData1.append("ScreenData", JSON.stringify(formData));

        if (this.ApprovalId == null || this.ApprovalId == undefined || this.ApprovalId == "") {
          this.reviewService.Insert("api/Approval/Insert", formData1 ).subscribe(result => {
            if (result.Status == 0) {
              this.setUpApprovalForm.controls["ID"].setValue(result.TransactionID);
              this.ApprovalId = result.TransactionID;
              this.commonService.SuccessBanner(result.Message);
              this.modalRef.close(result);
             // this.GetDocuments();
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
        else {
          this.reviewService.Update("api/Approval/Update", formData1).subscribe(result => {
            if (result.Status == 0) {
              this.setUpApprovalForm.controls["ID"].setValue(result.TransactionID);
              this.ApprovalId = result.TransactionID;
              this.commonService.SuccessBanner(result.Message);
              this.modalRef.close(result);
             // this.GetDocuments();
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
      }
      }
      else {
        var err: any = [];
        if (!this.setUpApprovalForm.controls["ApprovalOwnerddl"].disabled && this.setUpApprovalForm.controls["ApprovalOwnerddl"].value == "") {
          err.push("Please select the Approval Owner");
          this.commonService.ValidationBanner(err);
          return false;         
          }
        let formData = {
          "ID": this.ApprovalId, "MODULE_ID": this.ModuleID, "Application_Code": this.appCode
          , "CurrentOwner": this.setUpApprovalForm.controls["ApprovalOwnerddl"].value, "GrantType": this.SubModule
        };
        this.reviewService.Changeowner_Review("api/Approval/Changeowner_Approval", formData).subscribe(result => {
          if (result.Status == 0) {
            this.commonService.SuccessBanner(result.Message);
            this.modalRef.close(result);
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }
        });

      }   
    }

    validateControls(): boolean {
    
        let isValid = true;
        let message = "";
        const formData = this.setUpApprovalForm.getRawValue();

        if ((formData.APPROVAL_TYPE === null || formData.APPROVAL_TYPE === "" || formData.APPROVAL_TYPE === undefined) ) {
          $("#APPROVAL_TYPE").addClass("ng-touched ng-invalid validate-error");
          $("#APPROVAL_TYPE").removeClass("ng-untouched ng-valid");
          message += `Please select Approval Title <br/>`
          isValid = false;
        } else {
          $("#APPROVAL_TYPE").addClass("ng-untouched ng-valid");
          $("#APPROVAL_TYPE").removeClass("ng-touched ng-invalid validate-error");
        }
    
        if ((formData.Title === null || formData.Title === "" || formData.Title === undefined) && this.isSeletedOthers ) {
          $("#Title").addClass("ng-touched ng-invalid validate-error");
          $("#Title").removeClass("ng-untouched ng-valid");
          message += `Please enter Title <br/>`
          isValid = false;
        } else {
          $("#Title").addClass("ng-untouched ng-valid");
          $("#Title").removeClass("ng-touched ng-invalid validate-error");
        }
    
    
        if(this.SelectDocs == undefined || this.SelectDocs.length <= 0)
        {
          message += `Please select atleast one document for approval to save the details <br/>`
          isValid = false;
        }
    
        if (formData.PlannedEndDate === null || formData.PlannedEndDate === "") {
          $("#PlannedEndDate").addClass("ng-touched ng-invalid validate-error");
          $("#PlannedEndDate").removeClass("ng-untouched ng-valid");
          message += `Please select Planned end date <br/>`
          isValid = false;
        } else {
          $("#PlannedEndDate").addClass("ng-untouched ng-valid");
          $("#PlannedEndDate").removeClass("ng-touched ng-invalid validate-error");
        }
    
        if(this.selectedUsers == undefined || this.selectedUsers.length <= 0)
        {
          message += `Please select atleast one approver to save the details <br/>`
          isValid = false;
        }
    
        if (!isValid)
          this.commonService.ValidationBanner(message);
    
        return isValid;
      }

  GetApplicationDetails(){
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {   
        this.ModuleID = this.commonService.getModuleId(params['module']);
        this.ApplicationID = this.commonService.appId;//params['id'];
        this.SubModule = params['submodule'];
      }
    });
  }

  approvaltitleType($event: any){
    if($event == "Other")
    {
      this.isSeletedOthers = true;
    } else{
      this.isSeletedOthers = false;
      this.setUpApprovalForm.controls["Title"].setValue("");
    }
  }

  approvalDocuments(Type: string) {
    let files;
        let fileList;
        if(Type == "Select"){
          fileList = this.SelectDocs;
          this.isDocFromSystem  = true;
        } else{
          fileList = this.ReferenceDocs;
        }
    
        let modalRef = this.modalService.open(ReviewDocumentsModelComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-lg modal-dialog-center',
          animation: true
        });
    
        modalRef.componentInstance.Content = {
          fileList: files, DocType: Type, SelectedFiles: fileList,
          module: this.ModuleID, subModule: this.SubModule, ApplicationId: this.appId, ApplicationCode : this.appCode,
          Heading: this.Content.heading,
          isApprovalDocfromApp: this.isApprovalDocfromApp
        };
        modalRef.result.then(result => {
          if (Type == "Select") {
            this.isApprovalDocfromApp = result.isAppchecked;
            if (this.isApprovalDocfromApp) {
               this.SelectDocs = [];
              result.selectedfiles.forEach(element => {
                element['Status'] = "Add"
                this.SelectDocs.push(element);
              });
              if(!this.isDocFromSystem) {  this.ReferenceDocs = [];}
              this.reviewService.GetDocuments("api/Review/GetDocuments?ApplicationID=" +  this.appId + "&Module=" + this.ModuleID).subscribe(result1 => {
                if (result1["GetReferenceDocuments"] != null) {
                 result1["GetReferenceDocuments"].forEach(item=>{
                  this.ReferenceDocs.push(item)
                 })
                  this.ReferenceDocs.forEach(file => {
                    let ext = file.FileName.match(/\.([^\.]+)$/)[1];
                    file.FileExt = ext;
                  })
                }
               });
            }
            else {
             this.SelectDocs.forEach(file=>{
              if(file.isSelectedApplication) 
              {
                let index =result.selectedfiles.findIndex(x => x.FileID == file.FileID);
                this.SelectDocs.splice(index,1);
              }
             })
            result.selectedfiles.forEach(element => {
              this.SelectDocs.push(element); 
              this.isApprovalDocfromApp = result.isAppchecked;
            });   
            }
    
    
          } else { 
            result.selectedfiles.forEach(element => {
              this.ReferenceDocs.push(element); 
            });    
          }
        });
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  isAllowedExtensionFile(Filename)
  {
    return this.commonService.isAllowedExtension(Filename);
  }

  DownloadFile(ID) {
      var fileID = ID;
      let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
      window.open(Url);
  }

  DeleteUpload(file): void {
    let index;
    index = this.SelectDocs.findIndex(x => x.FileID == file.FileID);
    this.SelectDocs.splice(index, 1);
    if (file.isSelectedApplication)
      this.isApprovalDocfromApp = false;
  }
  resetInput(event: Event) {
  (event.target as HTMLInputElement).value = '';
}

  uploadchange(event: any) {
    if (this.ReferenceDocs == undefined || this.ReferenceDocs == null) {
          this.ReferenceDocs = [];
        }
      
      let Isexe = false;
      let Is5oMB = false;
    
        let hasMultipleFiles = false;
        let Duplicate_File_List = [];
    
        for (let i = 0; i < event.target.files.length; i++) {
          let uploadFile = new DocumentUploadFile();
          let file = event.target.files[i].name;   
          let ext = file.match(/\.([^\.]+)$/)[1];
          let filesize = event.target.files[i].size;
    
          if (file != null && (ext == 'exe')) {
            Isexe = true;        
          }
          else if (file != null && ((filesize > 52428800))) {
            Is5oMB = true;
          }
          else 
          {
            uploadFile.ID = this.commonService.getUniqueId();
            uploadFile.FileName = event.target.files[i].name;
            uploadFile.FileExt = ext;
            uploadFile.File = event.target.files[i];
            uploadFile.Status = "Add";      
            this.ReferenceDocs.push(uploadFile);
            
            //uploadFile["FileID"] = uploadFile.ID;        
            this.uploadedFiles.push(uploadFile);
          }
        }
    
        if (Is5oMB && Isexe) {
          this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
        }
    
        else if (Is5oMB) {
          this.commonService.ValidationBanner("Accepts maximum file size 50MB");
        }
    
        else if (Isexe) {
          this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
        }
        else {
    
        }
  }

  DeleteRefereUpload(file): void {
    let index = this.ReferenceDocs.findIndex(x => x.FileID == (file.FileID != undefined )? file.FileID : file.ID);
    this.ReferenceDocs.splice(index, 1);  
    this.uploadedFiles.splice(index, 1);  
  }
  approvalContributors(){
     let previousSelectedRolesInPop: any = [];
    this.selectedRolesInPop.forEach(element => {
      let obj = {
        RoleID: element.RoleID,
        RoleName: element.RoleName,
        UserID: element.UserID,
        UserName: element.UserName
      }
      previousSelectedRolesInPop.push(obj)
    });


    let modalRef = this.modalService.open(ReviewContributorsModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md modal-dialog-center',
      animation: true
    });
    modalRef.componentInstance.Content = {
      users: this.internalUsers, selectedUser: this.selectedUsers,
      module: this.ModuleID, subModule: this.SubModule, ApplicationId: this.appId,
      TaskType:"Approval"
    };

    modalRef.result.then((result) => {
      result.forEach(element => {
        this.selectedUsers.push(element); 
      });  
    });
  }

  startDateSelect(event) {
    this.isStartDateModified = true;
    this.Planned_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23, 
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }

  Delete(user: any) {
    let findIndex = this.selectedUsers.findIndex(X=> X.UserID == user.UserID);
    if(findIndex != null){
      this.selectedUsers[findIndex].isSelected = false;
      this.selectedUsers.splice(findIndex, 1);
    }
  }

}
